import "./App.css";
import { useRoutes } from "react-router-dom";
import { routes } from "./routes/router";
import "./i18n/i18n";

const App = () => useRoutes(routes);
export default App;
